import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/TimesheetAnalyze/timesheetAnazlyze.html'
})


export class TimesheetAnalyzeComponent implements OnInit {
    constants: Constants;
    projectList: any = [];
    projectListNew: any = [];
    timesheetItems: any = [];
    siteUserItems: any = [];
    userDetail: any;
    userList: any = [];
    teamList: any = [];
    taskgroupList: any = [];
    taskTypeList: any = [];
    taskTypeSortList: any = [];
    NewtaskTypeSortList: any = [];
    NewtaskTypeSortListNew: any = [];
    displayData: any = [];
    UpdateList: any = [];
    UpdateListNew: any = [];
    // projectidList:any =[];
    objSiteUserItem: any = [];
    newTaskGroupList: any = [];
    selfuser: boolean = true;
    public showLoader = false;
    selectAll: any = false;
    selectedTimesheetItems: string = "";
    IsDisabled: boolean = true;
    StatusList: any = [{ id: 0, Value: 'Processed' }, { id: 1, Value: 'Billable' }, { id: 2, Value: 'Non-Billable' }];

    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'TaskType_Id': "", 'TaskGroup_Id': "", 'TeamId': "", 'UserId': "", 'StatusId': "1" };
    UpdateObj: any = { 'ProjectId': "", 'TaskType_Id': "" };
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
        this.filter.TeamId = "";
    }

    ngOnInit() {

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;

        // this.GetProjectList(val);
        // this.GetUserList();
        this.GetUserListbyproj();
        this.GetTimesheet(true);
        // this.GetteamList();
        this.changeUserId(0);
        this.changeProjectId(0);
        this.GetProjectList(0);
        this.GetProjectListForChange(0);
        this.changeTaskTypeById("");
        this.changeTaskTypeByIdForChange("");

        //   this.GettaskGroupList();
        // this.GettaskTypeList();
    }

    ngAfterViewInit() {


        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        $('#projectIdFilter').select2().val("").trigger("change");
        $('#projectIdFilter').on(
            'change',
            (e) => {
                this.filter.ProjectId = $(e.target).val();
                this.changeProjectId(this.filter.ProjectId)
            }
        );

        $('#userIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').on(
            'change',
            (e) => this.filter.UserId = jQuery(e.target).val()
        );

        $('#taskTypeIdFilter').select2().val("").trigger("change");
        $('#taskTypeIdFilter').on(
            'change',
            (e) => this.filter.TaskType_Id = jQuery(e.target).val()
        );

    }

    GetUserListbyproj() {
        //   this.filter.UserId="";
        var teamId = this.userDetail.TeamID;

        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetUsers', {
            "IsActive": 1,
            "Team": this.userDetail.TeamID,
            "UserId": this.userDetail.SiteUserId
        }).subscribe(
            data => {
                this.userList = data["Users"];
                $(".project").val('').selectpicker('refresh');
            },
            err => {
                console.log("GetUserList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    GetteamList() {
        // this.filter.UserId="";
        this.showLoader = true;
        //   this.filter.UserId="";
        this._httpService.ajaxPost("Team/GetAssignedTeam", { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.teamList = data["AssignedTeam"];
            },
            err => {
                console.log("GetTeamList Failed");
                this.showLoader = false;
            },
            () => {
                this.GetUserListbyproj();
                this.showLoader = false;
            }
        );
    }

    GetProjectList(val) {
        this.filter.ProjectId = "";
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0 && val == "") {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        else {
            UserId = val;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetProjectByuser",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
                data => {
                    this.projectList = data["ProjectList"];
                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    GetProjectListForChange(val) {
        this.filter.ProjectId = "";
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0 && val == "") {
            UserId = this.userDetail.SiteUserId;
            // TeamId = this.userDetail.TeamID;
        }
        else {
            UserId = val;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetProjectByuser",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
                data => {
                    this.projectListNew = data["ProjectList"];
                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    changeProjectId(val) {
        this.showLoader = true;
        this.filter.TaskGroup_Id = "";
        if (val == "" || val == null) {
            this._httpService.ajaxPost("Project/GetProjectById",
                { "ProjectId": 0 }).subscribe(
                    data => {
                        this.taskgroupList = data["ProjectList"];
                    },
                    err => {
                        this.showLoader = false;

                    },
                    () => {
                        this.showLoader = false;
                    })
            this.filter.TaskGroupId = "";
        }
        else {
            this._httpService.ajaxPost("Project/GetProjectById",
                { "ProjectId": val }).subscribe(
                    data => {
                        this.taskgroupList = data["ProjectList"];
                        if (val == "") { }
                        else {
                            if (this.taskgroupList.filter((item) => item.Project_Id == val).length != 0) {
                                this.filter.TaskGroupId = this.taskgroupList.filter((item) => item.Project_Id == val)[0].TaskGroupId;
                            }
                        }
                        // setTimeout(function () {
                        //     $(".project").selectpicker('refresh');
                        // }, 1000);
                    },
                    err => {
                        console.log("GetProjectidList Failed");
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
        }

        this.changeTaskTypeId(val);
    }

    changeTaskTypeById(val) {
        this.showLoader = true;
        this.filter.TaskType_Id = ""
        if (val == "" || val == null) {
            this._httpService.ajaxPost("Project/GetTasktypeByTaskGroup",
                { "TaskGroupId": val }).subscribe(
                    data => {
                        this.NewtaskTypeSortList = data["ProjectList"];
                        this.UpdateList = this.NewtaskTypeSortList;
                    },
                    err => {
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                    })
        } else {
            this._httpService.ajaxPost("Project/GetTasktypeByTaskGroup",
                { "TaskGroupId": val }).subscribe(
                    data => {
                        this.NewtaskTypeSortList = data["ProjectList"];
                        this.UpdateList = this.NewtaskTypeSortList;
                        // JSON.parse(JSON.stringify(this.NewtaskTypeSortList.filter((item) => item.TaskGroupId == this.filter.TaskGroup_Id)));
                    },
                    err => {
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                    })


        }
    }

    changeTaskTypeByIdForChange(val) {
        this.showLoader = true;
        this.filter.TaskType_Id = ""
        if (val == "" || val == null) {
            this._httpService.ajaxPost("Project/GetTasktypeById",
                { "ProjectId": val }).subscribe(
                    data => {
                        this.NewtaskTypeSortListNew = data["ProjectList"];
                        this.UpdateListNew = this.NewtaskTypeSortListNew;
                    },
                    err => {
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                    })
        } else {
            this._httpService.ajaxPost("Project/GetTasktypeById",
                { "ProjectId": val }).subscribe(
                    data => {
                        this.NewtaskTypeSortListNew = data["ProjectList"];
                        this.UpdateListNew = this.NewtaskTypeSortListNew;
                        // JSON.parse(JSON.stringify(this.NewtaskTypeSortList.filter((item) => item.TaskGroupId == this.filter.TaskGroup_Id)));
                    },
                    err => {
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                    })


        }
    }

    changeUserId(val) {
        console.log(this.filter.TeamId);
        console.log(this.userList);
        if (val == "") { }
        else {
            this.objSiteUserItem = [];
            this.objSiteUserItem = this.siteUserItems.filter((item) => item.TeamID == val);
            if (this.objSiteUserItem.length > 0) {
                this.filter.UserId = this.objSiteUserItem[0].Site_UserId;
            }
            else {
                this.filter.UserId = "";
            }
            // this.filter.UserId= this.userList.filter((item) => item.TeamID == val)[0].SiteUser_Id;
        }

    }


    changeTaskTypeId(val) {
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetTasktypeById",
            { "ProjectId": val }).subscribe(
                data => {
                    this.taskTypeSortList = data["ProjectList"];
                },

                err => {
                    console.log("GetProjectidList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }

            );
    }

    public clearFilter() {
        this.filter = { 'ProjectId': "", 'TaskType_Id': "", 'UserId': "", 'TeamId': "", 'TaskGroup_Id': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
        this.filter.TeamId = "";

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;

        $('#projectIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').select2().val("").trigger("change");
        $('#taskTypeIdFilter').select2().val("").trigger("change");
        this.changeTaskTypeById("");
        //  this.changeTaskTypeByIdForChange("");
    }

    GetTimesheet(flag: boolean) {
        this.showLoader = true;
        this.selfuser = flag;
        var UserId = 0
        if (this.filter.UserId == "") {
            //UserId = this.userDetail.SiteUserId
        }
        else {
            UserId = this.filter.UserId
        }
        var TeamId = "0"
        if (this.filter.TeamId == "") {
            TeamId = this.userDetail.TeamID
            // TeamId = this.constants.TeamId;
        }
        else {
            TeamId = this.filter.TeamId
        }
        this._httpService.ajaxPost("Timesheet/GetTimesheet",
            {
                "TimesheetId": 0,
                "UserId": UserId,
                "ProjectId": this.filter.ProjectId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "TaskTypeId": this.filter.TaskType_Id,
                "TaskGroupId": this.filter.TaskGroup_Id,
                "TeamId": TeamId,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(
                data => {
                    var timesheetItemsData = data["TimesheetList"];
                    if (this.filter == null || this.filter.StatusId == "") {
                        this.timesheetItems = timesheetItemsData;
                    }
                    else {
                        this.timesheetItems = timesheetItemsData.filter(x => x.StatusId == this.filter.StatusId);
                    }
                    // this.timesheetItems.forEach(element => {
                    //     element.TimeSheet_Date = this.datePipe.transform(element.TimeSheet_Date, "dd-MM-yyyy");
                    // });
                },
                err => {
                    console.log("GetTimesheetList Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this._httpService.ajaxPost("Common/GetSiteUser").subscribe(
                        data => {
                            this.siteUserItems = data["SiteUser"];
                        },
                        err => {
                            this.showLoader = false
                        },
                        () => {
                            this.showLoader = false;
                        });
                    this.showLoader = false;
                });
    }

    onSelectAll() {
        if (this.selectAll) {
            this.timesheetItems.forEach(element => {
                if (element.Process_Id == 0) {
                    element.IsChecked = true;
                }
            });
        } else {
            this.timesheetItems.forEach(element => {
                if (element.Process_Id == 0) {
                    element.IsChecked = false;
                }
            });
        }
        this.onSelectInventory();
    }

    onSelectInventory() {
        if (this.timesheetItems.filter(x => x.IsChecked == true).length > 0) {
            this.IsDisabled = false;
        } else {
            this.IsDisabled = true;
        }

        if (this.timesheetItems.filter(x => x.IsChecked != true).length > 0)
            this.selectAll = false;
        else
            this.selectAll = true;
    }

    UpdateTimesheet() {
        this.showLoader = true;
        this.selectedTimesheetItems = "";
        this.timesheetItems.forEach(element => {
            if (element.IsChecked == true) {
                this.selectedTimesheetItems = element.TimeSheet_Id + ',' + this.selectedTimesheetItems;
            }
        });
        this.selectedTimesheetItems = this.selectedTimesheetItems.slice(0, -1)
        if (this.validateData()) {
            this._httpService.ajaxPost('Timesheet/UpdateProjectTaskInTimesheet', { "TimeSheetId": this.selectedTimesheetItems, "ProjectId": this.UpdateObj.ProjectId, "TaskTypeId": this.UpdateObj.TaskType_Id, "LoggedInUser": this.userDetail.SiteUserId }).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this._sharedService.ShowMessage(data["Status"].Message);
                        if (msg[0] != "error") {
                            this.GetTimesheet(true);
                            this.selectAll = false;
                            this.UpdateObj = { 'ProjectId': "", 'TaskType_Id': "" };
                            this.IsDisabled = true;
                        }
                        this.showLoader = false;
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this.showLoader = false;
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                },
                (error: any) => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage("error|Something went wrong.");
                }
            );
        }
        this.showLoader = false;
    }

    validateData() {
        var flag = true;
        if (this.selectedTimesheetItems == "" || this.selectedTimesheetItems == null) {
            flag = false;
            this._sharedService.ShowMessage("error|Select atleast one record.");
        }
        if ((this.UpdateObj.ProjectId == null || this.UpdateObj.ProjectId == "" || this.UpdateObj.ProjectId == 0) && (this.UpdateObj.TaskType_Id == null || this.UpdateObj.TaskType_Id == "" || this.UpdateObj.TaskType_Id == 0)) {
            flag = false;
            this._sharedService.ShowMessage("error|Select Project/Task Type to Update.");
        }
        return flag;
    }

    validateIsBillable() {
        var flag = true;
        if (this.selectedTimesheetItems == "" || this.selectedTimesheetItems == null) {
            flag = false;
            this._sharedService.ShowMessage("error|Select atleast one record.");
        }
        return flag;
    }

    UpdateUnBillable(IsBillable) {
        this.showLoader = true;
        this.selectedTimesheetItems = "";
        this.timesheetItems.forEach(element => {
            if (element.IsChecked == true) {
                this.selectedTimesheetItems = element.TimeSheet_Id + ',' + this.selectedTimesheetItems;
            }
        });
        this.selectedTimesheetItems = this.selectedTimesheetItems.slice(0, -1)
        if (this.validateIsBillable()) {
            this._httpService.ajaxPost('Timesheet/UpdateIsBillable', { "TimeSheetId": this.selectedTimesheetItems, "LoggedInUser": this.userDetail.SiteUserId, "IsBillable": IsBillable }).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {

                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                        if (msg[0] != "error") {
                            this.GetTimesheet(true);
                            this.selectAll = false;
                            this.UpdateObj = { 'ProjectId': "", 'TaskType_Id': "" };
                            this.IsDisabled = true;
                        }
                        this.showLoader = false;
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this.showLoader = false;
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                },
                (error: any) => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage("error|Something went wrong.");
                }
            );
        }
        this.showLoader = false;
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/TimesheetAnalyze/timesheetAnazlyze.component.ts
 **/